/*
 *
 * Page: `@dbh/view-invoices-payment-page`.
 *
 */const importViewInvoicesPaymentPage=()=>import('./component-55e5b506.js'/*  webpackChunkName: 'dbh.wiew-invoices-payment-page.component' */);const importViewInvoicesPaymentPageSsr=()=>import('./ssr-5bfab85f.js'/*  webpackChunkName: 'dbh.view-invoices-payment--page.ssr' */);

export { importViewInvoicesPaymentPage, importViewInvoicesPaymentPageSsr };
